import { Carousel } from "@trendyol-js/react-carousel";
import React from "react";
import CustomRightArrow from "./CustomRightArrow";
import CustomLeftArrow from "./CustomLeftArrow";

const Empresa = () => {
  return (
    <section className="bg-[#FAFAFA]">
      <div className="container mt-5 mb-5" id="empresa">
        <div className="cards flex gap-6 w-full">
          <div className="w-[37rem] min540:w-[100%] shadow-xl flex flex-col px-[3rem] py-[5rem]">
            <h3 className="text-[22px] font-bold py-5">História da empresa</h3>
            <p className="text-[15px] text-[#646464] font-medium">
              Fundada em 1999, a MW INFORMÁTICA LTDA., nasce para conquistar
              novos mercados, implementando uma concepção inovadora em
              equipamentos e soluções para informática.
            </p>
          </div>
          <div className="w-[37rem] min540:w-[100%] shadow-xl flex flex-col px-[3rem] py-[5rem]">
            <h3 className="text-[22px] font-bold py-5">Objetivo</h3>
            <p className="text-[15px] text-[#646464] font-medium">
              A MW INFORMÁTICA LTDA se propõe a atender, com qualidade,
              pontualidade e confiança aos seus clientes com tempo cada vez
              menor, com os melhores produtos através de preços competitivos e
              liberdade de escolha.
            </p>
          </div>
          <div className="w-[37rem] min540:w-[100%] shadow-xl flex flex-col px-[3rem] py-[5rem]">
            <h3 className="text-[22px] font-bold py-5">Sobre</h3>
            <p className="text-[15px] text-[#646464] font-medium">
              Hoje, a MW INFORMÁTICA LTDA conta com uma linha completa de
              equipamentos, peças, acessórios, suprimentos e soluções para
              informática em geral, que atendem desde o processo inicial de
              informatização às soluções mais complexas.
            </p>
          </div>
        </div>
        <br />
        <div className="flex justify-center mt-[10px]">
          <p className="text-[25px] text-slate-700 font-semibold">
            Conheça alguns dos nossos clientes:{" "}
          </p>
        </div>
        <br />
        <div id="carousel">
          <Carousel
            show={4.5}
            slide={2}
            swiping={true}
            leftArrow={<CustomLeftArrow />}
            rightArrow={<CustomRightArrow />}
            responsive={true}
            className="mt-5"
          >
            <img src="/images/ufmg.jpg" alt="UFMG" width={200} height={200} />
            <img src="/images/IFMG.jpg" alt="IFMG" width={200} height={200} />
            <img src="/images/INSS.jpg" alt="INSS" width={200} height={200} />
            <img
              src="/images/lavras.png"
              alt="LAVRAS"
              width={200}
              height={200}
            />
            <img
              src="/images/serpro-logo.png"
              alt="SERPRO"
              width={200}
              height={200}
            />
            <img src="/images/UFSJ.jpg" alt="UFSJ" width={200} height={200} />
            <img src="/images/UFOP.png" alt="UFOP" width={200} height={200} />
            <img src="/images/ufjf.png" alt="UFJF" width={200} height={200} />
            <img src="/images/DERMG.jpg" alt="DERMG" width={200} height={200} />
            <img
              src="/images/divina.jpg"
              alt="Divina"
              width={200}
              height={200}
            />
            <img
              src="/images/fundep.png"
              alt="FUNDEP"
              width={200}
              height={200}
            />
            <img
              src="/images/christiano.jpg"
              alt="Christiano"
              width={200}
              height={200}
            />
            <img src="/images/UFSJ.jpg" alt="UFSJ" width={200} height={200} />
            <img
              src="/images/inmetro.jpg"
              alt="INMETRO"
              width={200}
              height={200}
            />
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default Empresa;
